import type {
  DailyRun,
  RunDetailResponse,
  SummaryResponse,
} from "./types";

async function getJson<T>(url: string): Promise<T> {
  const response = await fetch(url, {
    headers: { accept: "application/json" },
  });
  if (!response.ok) {
    let detail = "";
    try {
      const body = await response.json();
      if (body && typeof body === "object" && "error" in body) {
        detail = String((body as { error: unknown }).error);
      }
    } catch {
      // ignore body parse errors
    }
    throw new Error(
      `Request failed (${response.status} ${response.statusText})${
        detail ? `: ${detail}` : ""
      }`
    );
  }
  return (await response.json()) as T;
}

export const api = {
  summary(): Promise<SummaryResponse> {
    return getJson<SummaryResponse>("/api/runs/summary");
  },
  runs(limit = 180): Promise<DailyRun[]> {
    return getJson<DailyRun[]>(`/api/runs?limit=${limit}`);
  },
  run(id: number | string): Promise<RunDetailResponse> {
    return getJson<RunDetailResponse>(`/api/runs/${encodeURIComponent(String(id))}`);
  },
};
